/*
 * Lead Profile Creation
 */

import React from "react";

import NewDealer from "./NewDealer";

interface defaultProps {}

const DealerPreAppointment = (props: any) => {
  const { header, selectedRow, onClose } = props;
  return (
    <>
      <NewDealer selectedRow={selectedRow} onClose={onClose} />
    </>
  );
};

export default DealerPreAppointment;
